/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.25/esri/copyright.txt for details.
*/
function t(t){const e=1e5,n=1e6;return Math.min(1,Math.max(0,(t-e)/(n-e)))}const e=1e4,n=.085,o=1e5;export{o as atmosphereHeight,t as computeInnerAltitudeFade,e as innerAtmosphereDepth,n as rayLeighScaleHeight};
